/// <reference types="@angular/localize" />
/*import * as $ from 'jquery';
(window as any).$ = $;
(window as any).jQuery = $;*/

declare var Modernizr: any;
//declare var jQuery: any;

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import { getTranslationProviders } from './app/i18n-providers';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
.catch(err => {
    console.error(err);
  });
/*getTranslationProviders().then(providers => {
  const options = { providers };
  platformBrowserDynamic().bootstrapModule(AppModule, options);
});*/